var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-col',{attrs:{"xs":"12","sm":"6","md":"4","lg":"3"}},_vm._l((_vm.elements),function(element){return _c('ObjectsListItem',{key:element.id,attrs:{"element":element,"parentId":_vm.parentId}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }